import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg48VideoChatG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("rect", {
        width: 48,
        height: 48,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
        rx: 4
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        d: "M28.567 13a2.933 2.933 0 0 1 2.933 2.933v16.134A2.933 2.933 0 0 1 28.567 35H12.433A2.933 2.933 0 0 1 9.5 32.067V15.933A2.933 2.933 0 0 1 12.433 13zm11.856 5.102q.077.27.077.55v10.697a2 2 0 0 1-2.55 1.923l-3-.858a2 2 0 0 1-1.45-1.923V19.51a2 2 0 0 1 1.45-1.923l3-.858a2 2 0 0 1 2.473 1.374zm-25.533-.858-.007.011c-1.368 1.946-1.112 4.627.608 6.346l5.04 5.04c1.72 1.72 4.4 1.977 6.346.608l.011-.007c.823-.62.892-1.836.149-2.58l-1.298-1.297c-.678-.679-1.765-.69-2.427-.028-.56.56-1.477.549-2.05-.023l-2.444-2.445c-.572-.572-.583-1.49-.023-2.049.662-.662.65-1.749-.028-2.427l-1.297-1.297c-.744-.744-1.96-.676-2.58.148"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg48VideoChatG$1 = Svg48VideoChatG;

export { Svg48VideoChatG$1 as default };
